<template>
  <div>
    <fixed-header title="Email Templates" hideNewOfferBtn>
      <AddEmailTemplate v-if="checkClaim(CAN_MANAGE_EMAIL_TEMPLATE)" @onChange="getEmailTemplates" :templateData="templateData" @clearProps="templateData={}"></AddEmailTemplate>
    </fixed-header>
    <div class="animated fadeIn BillPayments--BillPayments-list">
      <div class="card">
        <div class="card-body d-flex flex-column">
          <grid-component
            isResizable
            :gridId="gridId"
            :canEdit="checkClaim(CAN_MANAGE_EMAIL_TEMPLATE)"
            :canDelete="checkClaim(CAN_MANAGE_EMAIL_TEMPLATE)"
            :itemData="itemData"
            :fields="fields"
            :onEdit="onEdit"
            :handleRowClick="handleRowClick"
            :onDelete="onDelete"
            :styleCustom="'height: 765px'"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';
  import FixedHeader from '@/shared/components/FixedHeader/indexNew';
  import GridSettings from '@/shared/components/GridSettings';
  import GridComponent from '@/shared/components/GridComponent';
  import AddEmailTemplate from './components/Add'
  import fields from './fields';
  import service from './service';

  export default {
    components: {
      GridSettings,
      FixedHeader,
      GridComponent,
      AddEmailTemplate
    },
    data() {
      return {
        fields,
        gridId: 'email-table',
        tableList: [],
        lookupTableValues: [],
        templateData: {},
        selectedRowId:0,
      };
    },
    metaInfo: () => ({
      title: 'Email Template Management',
    }),
    computed: {
      ...mapGetters('lookup', ['emailTemplates']),
      itemData() {
        return this.emailTemplates.map((lookup) => ({ ...lookup, selected: lookup.id === this.selectedRowId }));
      },
    },
    methods: {
      ...mapActions('lookup', ['getEmailTemplates']),
      // async getEmailTemplates() {
      //   this.lookupTableValues = await service.getEmailTemplate();
      // //  console.log(this.lookupTableValues);
      // },
      onEdit(row){
        this.selectedRowId = row.id;
        this.templateData = row;
        this.$root.$emit('bv::show::modal', 'email-template-modal');
      },
      handleRowClick(row) {
        //this.selectedRowId = row.dataItem.id;
        //this.templateData = row.dataItem;
      },
      async onDelete(row) {
        const deleteConfirmed = await this.openConfirmBox({});
        if (deleteConfirmed) {
            await service.deleteEmailTemplate(row.id);
            //Get the data
            this.getEmailTemplates();
        }
      },
    },
  };
</script>
